import MobileTabSwitcher from "@components/switcher/MobileTabSwitcher";
import AccountApprovals from "../../affiliate-management/AccountApprovals";
import CurrentAffiliates from "../../affiliate-management/CurrentAffiliates";
import MerchantApprovalMapping from "../../affiliate-management/MerchantApprovalMapping";

const MobileAffiliateManagement = () => {
  const affiliateTabs = [
    { label: "ACCOUNT APPROVALS", component: <AccountApprovals /> },
    {
      label: "MERCHANT MAPPING APPROVALS",
      component: <MerchantApprovalMapping />,
    },
    { label: "CURRENT AFFILIATES", component: <CurrentAffiliates /> },
  ];
  return (
    <div
      className="flex flex-col w-full"
      style={{ height: "calc(100dvh - 56px)" }}
    >
      <div className="h-[56px] border-b border-border-subtle bg-bg-page-body flex flex-row sticky top-0 bg-white z-10 px-4 w-full shrink-0">
        <p className="flex text-text-base text-[14px] font-semibold items-center">
          Affiliate Management
        </p>
      </div>
      <div className="flex flex-col w-full px-3 mt-4 flex-1 min-h-0">
        <MobileTabSwitcher tabs={affiliateTabs} />
      </div>
    </div>
  );
};

export default MobileAffiliateManagement;
